import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import { LoadingContext } from "../../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../../services/api";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import NumberProps from "../NumberProps";
import { AuthContext } from "../../../../../contexts/Authentication/AuthContext";

export const NumbersDayDeliveredDocumentsSlaDealine = () => {
  const { id, shortToken , mode } = useParams();
  const { changeVisibility } = useContext(LoadingContext);
  const { reloadComponent, componentProperty } = useContext(DashboardContext);
  const { hasShortToken} = useContext(AuthContext);

  const [documents, setDocuments] = useState<{ count: number }>({ count: 0 });
  const [completeRequisition, setCompleteRequisition] = useState(false);

  let routeDocuments: string;

  if (hasShortToken) {
    routeDocuments = `/documents?graphic_id=numbersDayDeliveredDocumentsSlaDealine&short_token=${shortToken}&screen_id=${id}`;
  } else {
    routeDocuments = `/documents?graphic_id=numbersDayDeliveredDocumentsSlaDealine&screen_id=${id}`;
  }

  useEffect(() => {
    changeVisibility(true);
    const fetchData = async () => {
      try {
        await requisition();
      } finally {
        changeVisibility(false);
        setCompleteRequisition(true);
      }
    };
    fetchData();
    if (mode === "view") {
      const intervalId = setInterval(() => {
        requisition();
      }, 60000);
      return () => clearInterval(intervalId);
    }
  }, []);

  async function requisition() {
    return await api
      .get(routeDocuments)
      .then((routes: { data: { count: number } }) => {
        setDocuments(routes.data);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  }

  return completeRequisition && !reloadComponent ? (
    <div
      id="numbers-day-delivered-documents-sla-dealine"
      className="w-100"
    >
      <NumberProps
        value={documents}
        title="Docs entregues dentro SLA"
        id="numbers-day-delivered-documents-sla-dealine"
        clickable={componentProperty({
          id: "numbersDayDeliveredDocumentsSlaDealine",
          property: "redirect",
        })}
        scale={9}
      />
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
